import { commonApi } from '@/common/index'

export default {
    data(){
        return{
            bannerList:[]
        }
    },
    methods: {
        getBanner() {
            commonApi.HOMEBEFORE.fetchImg(this.bannerCode)
                .then((list) => {
                    this.bannerList = list
                    this.images = list[0];
                    console.log(list[0],this.bannerList)
                })
                .catch(err => { })
        },
    },
    mounted(){
        this.getBanner()
    }
}



// WEBPACK FOOTER //
// ./src/common/mixins/oldGetBanner/oldGetBanner.js